import React, { useEffect, useState } from 'react'
import { Input, Ref } from 'semantic-ui-react'
import * as R from 'ramda'

/**
 * @template T
 * @typedef {import('shared/components/FilterGroup/reducer').InputProps<T>} InputProps  */

/**
 * @template T
 * @param {InputProps<T>} props
 */
export default function FilterInput({ onChange, onClose, defaultFilters, ...props }) {
  const [previousValue, setPreviousValue] = useState('')
  function handleBlur(e) {
    const { value } = e.target
    if (value === previousValue || R.isEmpty(value)) {
      return
    }
    setPreviousValue(value)
    onChange([{ value }])
  }

  function handleSubmit(e) {
    e.preventDefault()
    e.stopPropagation()
    const { value } = e.target.input
    if (value === previousValue || R.isEmpty(value)) {
      return
    }
    onChange([{ value }])
    onClose()
  }

  const value = R.path([0, 'value'], defaultFilters)

  const [inputRef, setInputRef] = useState()
  useEffect(() => {
    if (inputRef) {
      // Prevent scrolling when focusing on an input element.
      // https://stackoverflow.com/a/48500276
      // https://github.com/simplesat/simplesat/issues/4982#issuecomment-951707931
      inputRef.querySelector('input').focus({ preventScroll: true })
    }
  }, [inputRef])

  return (
    <form onSubmit={handleSubmit}>
      <Ref innerRef={setInputRef}>
        <Input name="input" fluid {...props} onBlur={handleBlur} defaultValue={value} />
      </Ref>
    </form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/FilterInput/index.js